package one.healthium.notifications.scheduler

import kotlinx.datetime.Instant
import one.healthium.notifications.manager.Notification

actual class NotificationScheduler {
    actual suspend fun schedule(scheduleAt: Instant, notification: Notification) {
        // No-op in JS, as scheduling is not supported
    }

    actual fun cancel(id: Int) {
        // No-op in JS, as scheduling is not supported
    }

    actual fun cancel(ids: List<Int>) {
        // No-op in JS, as scheduling is not supported
    }

    actual fun cancelAll() {
        // No-op in JS, as scheduling is not supported
    }
}